// extracted by mini-css-extract-plugin
module.exports = {"Layout":"Layout-module--Layout--33CuK"};